import DamageTypePage from "@/components/damageType/DamageTypePage";

const PhishingSchutz = () => <DamageTypePage slug="phishing-schutz" />;
export default PhishingSchutz;
